import { render, staticRenderFns } from "./product-cart-actions.vue?vue&type=template&id=48168664&scoped=true"
import script from "./product-cart-actions.vue?vue&type=script&lang=js"
export * from "./product-cart-actions.vue?vue&type=script&lang=js"
import style0 from "./product-cart-actions.vue?vue&type=style&index=0&id=48168664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48168664",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTooltip: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseTooltip.vue').default,BaseAlert: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseAlert.vue').default,BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseButton.vue').default})
